import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Bookmark = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Bookmark' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='5 1 5 22 12 17 19 22 19 1' />
  </StyledIcon>
);
